import React, { useEffect, useRef, useState } from 'react';

import { nwkData, clone_data, early_pointmts_data, bulk_data, bulk_tile_data} from '../data/WebtoolData'

import GiPhylogram from "../chart/GiPhylogram"
import GiHuman from "../chart/GiHuman"

import Screen1Grid from "../card/grid/Screen1Grid"
import Screen1BarPlot from "../card/chart/Screen1BarPlot"
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface MatchParams {
  deadbody: string;
}

function Screen1({ history, match }: RouteComponentProps<MatchParams>) {

  const defaultDeadbodyValue:string = match.params.deadbody;
  const defaultScreenValue:string   = 'Screen1';

  let [isFirst, setFirst] = useState<boolean>(true);
  let [deadbody, setDeadbody] = useState<string>(defaultDeadbodyValue);

  const deadBasicData:any = nwkData();
  let [newickData, setNewickData] = useState(deadBasicData[deadbody].nwkData);
  let [sex, setSex] = useState(deadBasicData[deadbody].sex);

  const [cloneData, cloneDetailData] = clone_data();
  const early_pointmts_all_data = early_pointmts_data();
  const bulk_all_data = bulk_data();
  const bulkAllTileData = bulk_tile_data();

  let [cloneLocationData, setCloneLocationData] = useState(cloneData[deadbody]);
  let [earlyPointmtsData, setEarlyPointmtsData] = useState(early_pointmts_all_data[deadbody]);
  let [bulkData, setBulkData]                   = useState(bulk_all_data[deadbody]);
  let [bulkTileData, setBulkTileData]           = useState(bulkAllTileData[deadbody]);
  
  const card1:any = useRef();
  const card2:any = useRef();

  function clickOnPhylogram(clickPathDatas:any){
    let dataKeys:string[] = Object.getOwnPropertyNames(clickPathDatas);

    if(initScreen1Grid.click_on_path){
      let datas:any[] = initScreen1Grid.click_on_path(dataKeys);

      if(initBarPlot.clickOnRowWithScreen1Grid){
        initBarPlot.clickOnRowWithScreen1Grid([]);
      }
    }
  }

  function changeOnPhylogram(data:any, active:boolean, isClick?:boolean){
    if(initGiHumanData.change_on_human){
      initGiHumanData.change_on_human(data, active, isClick);
    }
  }

  let [initGiPhylogramData, setInitGiPhylogramData]= useState<any>({ 
    detail_title_field:{source_filed:'lineage_id_cindel', target_field:'sample_id' },
    width: 1000,
    height: 535,
    min_height: 535,
    max_height: 1000,
    legend_field: 'Cell_type',
    callback_after_mouseover_path: changeOnPhylogram,
    callback_after_click_path: clickOnPhylogram
  });

  let [initGiHumanData, setInitGiHumanData]= useState<any>({ 
    width: 540,
    height: 580,
    sex: sex
  });

  let [initScreen1Grid, setInitScreen1Grid] = useState<any>({
    click_on_row: clickOnRowWithScreen1Grid
  });

  let [initBarPlot, setInitBarPlot] = useState<any>({
    bulkTileData: bulkTileData,
    barplot_width: 1000
  });

  function changeScreenbody(screenValue: string){
    history.push({
      pathname:`/${screenValue}/${deadbody}`,
      state: {deadbody: deadbody}
    })
  }


  function changeDeadbody(deadbodyValue: string){
    setDeadbody(deadbodyValue);
  }

  // click grid
  function clickOnRowWithScreen1Grid(rowNum: number, row: any, bulkData:any){
    if(row.Target_seq === 'Y'){
      let bulkDataOfLineage:any = bulkData[row.lineage_id_cindel];

       if(bulkDataOfLineage && initBarPlot.clickOnRowWithScreen1Grid){
          initBarPlot.barplot_width = card1.current.offsetWidth;
          initBarPlot.clickOnRowWithScreen1Grid(bulkDataOfLineage[row.var_id], row);
       }
    }else{
      if(initBarPlot.clickOnRowWithScreen1Grid){
        initBarPlot.clickOnRowWithScreen1Grid([]);
     }
    }
  }

  useEffect(() => {
    initGiPhylogramData.width = card1.current.offsetWidth;
    initGiHumanData.width = card2.current.offsetWidth;
    initGiHumanData.sex = deadBasicData[deadbody].sex;
    initBarPlot.barplot_width = card1.current.offsetWidth;
    initBarPlot.human_width = card2.current.offsetWidth;

    initBarPlot.sex = deadBasicData[deadbody].sex;
    initBarPlot.bulkTileData = bulkAllTileData[deadbody];
    

    if(isFirst === false){
      setEarlyPointmtsData(early_pointmts_all_data[deadbody]);
      setBulkData(bulk_all_data[deadbody]);
      setNewickData(deadBasicData[deadbody].nwkData);
      setCloneLocationData(cloneData[deadbody]);
      setSex(deadBasicData[deadbody].sex);
      setBulkTileData(bulkAllTileData[deadbody])
      
      if(initScreen1Grid.click_on_path){
        initScreen1Grid.click_on_path([]);
      }

      if(initBarPlot.clickOnRowWithScreen1Grid){
        initBarPlot.clickOnRowWithScreen1Grid([]);
      }
    }
    setFirst(false);

    // return () => {
    //   setNewickData(NwkData()[deadbody]);
    //   setCloneLocationData(Clone_lineageID_location()[deadbody]);
    // }

  }, [deadbody]);

  return (
    <div className="wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label htmlFor="ScreenSelect"> Screen</label>
              <select className="form-control" id="DeadbodySelect" onChange={(e) => changeScreenbody(e.currentTarget.value)} defaultValue={defaultScreenValue}>
                  <option value="Screen1">Start from phylogenetic tree</option>
                  <option value="Screen2">Start from bulk tissue</option>
              </select>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label htmlFor="DeadbodySelect"> Donor ID</label>
              <select className="form-control" id="DeadbodySelect" onChange={(e) => changeDeadbody(e.currentTarget.value)} defaultValue={defaultDeadbodyValue}>
                <option value="DB2">DB2</option>  
                <option value="DB3">DB3</option>  
                <option value="DB5">DB5</option>  
                <option value="DB6">DB6</option>  
                <option value="DB8">DB8</option>  
                <option value="DB9">DB9</option>  
                <option value="DB10">DB10</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8">
            <div className="card card-primary">
                <div className="card-header">
                  <h3 className="card-title">Phylogenetic tree by clonal samples</h3>
                </div>
                <div className="card-body">
                  <div ref={card1}>
                    <GiPhylogram newickData={newickData} detailData={cloneLocationData} initialization={initGiPhylogramData} />
                  </div>
                  <p className="card-text">
                  When you click branches, you can see the location descendants in the right panel. When you click early branches, you can see the list of early mutations in the below panel.
                  </p>
                </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card card-primary">
                <div className="card-header">
                  <h3 className="card-title">Location of clonal samples</h3>
                </div>
                <div className="card-body">
                  <div ref={card2}>
                    <GiHuman cloneData={cloneLocationData} cloneDetailData={cloneDetailData} initialization={initGiHumanData}/>
                  </div>
                </div>
            </div>
          </div>
        </div>
        {isFirst === false && (
        <React.Fragment>
        <Screen1Grid gridData={earlyPointmtsData} bulkData={bulkData} initialization={initScreen1Grid}/>
        <Screen1BarPlot initialization={initBarPlot} sex={sex}/>
        </React.Fragment>
        )}
      </div> 
      </section>
    </div>
  );
  
}

export default withRouter(Screen1);